const isReactElement = child => {
  return child.props !== undefined;
};

export { isReactElement };
